export const DEBOUNCE_DELAY_300MS = 300;
export const DEBOUNCE_DELAY_600MS = 600;
